<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-09-20 11:43:05
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-09-22 10:54:27
 * @FilePath: \ces-vue-serve\src\views\Finance\components\refund.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="rj-page-card">
    <!-- <div class="rj-page-card__title">电汇查询</div> -->
    <div class="rj-page-card__content">
      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="业务实体:" prop="bussinessEntity">
          <el-select v-model="searchForm.bussinessEntity" placeholder="请选择" clearable>
            <el-option
              v-for="option in businessEntity"
              :key="option.dictValue"
              :label="option.dictLabel"
              :value="option.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="收款编号:" prop="telegraphicTransferNum">
          <el-input v-model.trim="searchForm.telegraphicTransferNum" placeholder="请输入收款编号" />
        </el-form-item>
        <el-form-item label="收款日期:" prop="startRemittanceDate">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.startRemittanceDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.endtRemittanceDate"
                type="date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                placeholder="选择日期"
                clearable
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="银行名称:" prop="accountDistrct">
          <el-select
            v-model="searchForm.accountDistrct"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="option in bankName"
              :key="option.dictValue"
              :label="option.dictLabel"
              :value="option.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="收款客户名称:" prop="importCompany">
          <el-input v-model.trim="searchForm.importCompany" placeholder="请输入收款客户名称" />
        </el-form-item>
        <el-form-item label="申请日期:" prop="createBeginTime">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.createBeginTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.createEndTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="当前状态:" prop="state">
          <el-select v-model="searchForm.state" placeholder="请选择" clearable>
            <el-option v-for="item in state" :key="item.dictValue"
                       :label="item.dictLabel"
                       :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-button type="primary" :loading="isLoading" @click="doSearch">
          查询
        </el-button>
        <el-button type="default" @click="resetForm('searchForm')">
          重置
        </el-button>
      </el-form>
      <el-table v-loading="isLoading" :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
        <el-table-column prop="businessEntity" label="业务实体" align="left" fixed="left" />
        <el-table-column prop="accountCompany" label="银行名称" align="left" />
        <el-table-column prop="remittanceDate" label="收款日期" align="left" />
        <el-table-column prop="telegraphicTransferNum" label="收款编号" align="left">
          <template v-slot="{row}">
            <el-button type="text" class="el-btn-text-left" @click="showInfo(row.telegraphicTransferNum)">
              {{ row.telegraphicTransferNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="actualRemittanceAmount" label="净收款额(元)" align="right" header-align="left" />
        <el-table-column prop="unusedAmount" label="可用余额(元)" align="right" header-align="left" />
        <el-table-column prop="returnAmount" label="申请退款金额(元)" align="right" header-align="left" />
        <el-table-column prop="applicationName" label="申请人" align="left" />
        <el-table-column prop="applicationTime" label="申请日期" align="left" />
        <el-table-column prop="stateAndApprover" label="当前状态" align="left" />
        <el-table-column prop="state" label="操作" width="120" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="lookDetail(row)">
              查看
            </el-button>
            <!-- 商务办理 -->
            <span v-if="perssimionCodeList.includes('businessWireTransferList') && row.state==='待商务审核' && row.isConduct">
              <el-button type="text" @click="handelFn(row)"> 办理</el-button>
            </span>
            <!-- 财务办理 -->
            <span v-if="!perssimionCodeList.includes('businessWireTransferList') && row.state==='待财务审核'">
              <el-button type="text" @click="handelFn(row)">办理</el-button>
            </span>
            <el-button v-if="perssimionCodeList.includes('businessWireTransferList') &&row.state ==='驳回待提交'" type="text" @click="editRefund(row)">
              编辑
            </el-button>
            <el-button v-if="perssimionCodeList.includes('businessWireTransferList') &&row.state ==='驳回待提交'" type="text" @click="abandonmentFn(row)">
              废弃
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>

    <el-dialog v-if="remittanceVisible" title="国内电汇详细信息" :visible.sync="remittanceVisible" width="800px">
      <remittance-info-box :id="telegraphicTransferNum" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="remittanceVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 办理 -->
    <handel-refund-dialog ref="handelRefundDialog" @on-ok="doSearch" />

    <!-- 查看 -->
    <refund-detail-dialog ref="refundDetailDialog" />

    <!-- 编辑 -->
    <edit-refund-dialog ref="editRefundDialog" @on-ok="doSearch" />
  </div>
</template>

<script>
import { getDictData, selectTelApplyRefund, abandonRefund } from '@/API';
import { mapState } from 'vuex';
import remittanceInfoBox from '../remittanceInfoBox';
import handelRefundDialog from './handelRefundDialog.vue';
import RefundDetailDialog from '../../wire-transfer-query/refund-query/RefundDetailDialog.vue';
import EditRefundDialog from '../../wire-transfer-query/refund-query/EditRefundDialog.vue';

export default {
  components: {
    remittanceInfoBox,
    handelRefundDialog,
    RefundDetailDialog,
    EditRefundDialog
  },

  data () {
    return {
      searchForm: {
        bussinessEntity: '',
        telegraphicTransferNum: '',
        startRemittanceDate: '',
        endtRemittanceDate: '',
        accountDistrct: '',
        createBeginTime: '',
        createEndTime: '',
        state: ''
      },
      businessEntity: [],
      bankName: [],
      options: [],
      state: [],
      isLoading: false,
      tableData: [],
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.startRemittanceDate) {
            let date = new Date(this.searchForm.startRemittanceDate);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.searchForm.createBeginTime) {
            let date = new Date(this.searchForm.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      remittanceVisible: false,
      telegraphicTransferNum: ''
    };
  },
  computed: {
    ...mapState({
      perssimionCodeList: state => state.user.perssimionCodeList // 登录权限
    })
  },
  mounted () {
    this.initData();
  },
  methods: {
    initData () {
      let parmas = ['business_entity', 'bank_name', 'state'];
      getDictData(parmas).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          // 下拉列表基础数据
          json.data.forEach((item) => {
            if (item.dictType === 'business_entity') {
              this.businessEntity = item.dictDataVOS;
            }
            if (item.dictType === 'bank_name') {
              this.bankName = item.dictDataVOS;
            }
            if (item.dictType === 'state') {
              this.state = item.dictDataVOS;
            }
          });
        }
      }).catch((err) => {
        console.log(err);
      });
      this.doSearch();
    },
    doSearch () {
      this.isLoading = true;
      selectTelApplyRefund({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.isLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
          this.isLoading = false;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.searchForm.endtRemittanceDate = '';
      this.searchForm.createEndTime = '';
      this.doSearch();
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.page.currentPage = val;
      this.doSearch();
    },
    showInfo (val) {
      this.telegraphicTransferNum = val;
      this.remittanceVisible = true;
    },

    // 查看
    lookDetail (row) {
      let data = JSON.parse(JSON.stringify(row));
      this.$refs.refundDetailDialog.openDialog(data);
    },

    // 编辑
    editRefund (row) {
      let data = JSON.parse(JSON.stringify(row));
      this.$refs.editRefundDialog.openDialog(data);
    },

    // 办理
    handelFn (row) {
      let data = JSON.parse(JSON.stringify(row));
      this.$refs.handelRefundDialog.openDialog(data);
    },

    // 废弃
    abandonmentFn ({ telApprovalId }) {
      this.$confirm('废弃后申请的退款金额将返还到电汇单上，你确定要废弃此退款申请吗？', '', {
        confirmButtonText: '废弃',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          abandonRefund({ telApprovalId }).then((res) => {
            let { status } = res.data;
            if (status === '200') {
              this.$message.success('废弃成功');
              this.doSearch();
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss">
  .m-10{
    margin-top: 10px;
    .rj-baseinfo{
      .el-form-item{
        margin-bottom: 0;
        .el-form-item__label{
          text-align: left;
          font-size: 14px!important;
        }
        .el-textarea{
          width: 660px;
        }
      }
    }

  }
  .mb-10{
    margin-bottom: 10px;
  }
</style>
